var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCounterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FEF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.251 17.4635V13.9485H16.7565V12.3525H13.251V8.8565H11.655V12.3525H8.14V13.9485H11.655V17.4635H13.251Z",
    fill: "#F73B58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCounterIcon);
export default __webpack_public_path__ + "static/media/add-counter-icon.fd4b1ceaeea550ed15bfbd836780b526.svg";
export { ForwardRef as ReactComponent };